import { Component, Input } from '@angular/core';
import { IAlbum, Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'pv-lightbox-images',
  templateUrl: './lightbox-images.component.html',
  styleUrls: ['./lightbox-images.component.scss']
})
export class LightboxImagesComponent {
  @Input() photos: {
    overlay_url: string;
    url: string;
    thumbnail_url: string;
    medium_url: string;
  }[]
  activeIndex = 0;

  constructor(private lightboxService: Lightbox) { }

  lightbox() {
    const album: IAlbum[] = this.photos.map(p => ({
      src: p.url,
      thumb: p.thumbnail_url
    }))
    this.lightboxService.open(album, this.activeIndex, {
      showImageNumberLabel: true,
      wrapAround: true,
      centerVertically: true
    })

  }

  getOverlayStyle() {
    if (this.photos[this.activeIndex] && this.photos[this.activeIndex].overlay_url) {
      return `url(${this.photos[this.activeIndex].overlay_url})`
    }
  }
}
